module.exports = new __parcel__URL__("logo.48f30edd.png").toString();